import { render, staticRenderFns } from "./CbsBulkUsers.vue?vue&type=template&id=c6a7d6d4&scoped=true"
import script from "./CbsBulkUsers.vue?vue&type=script&lang=js"
export * from "./CbsBulkUsers.vue?vue&type=script&lang=js"
import style0 from "./CbsBulkUsers.vue?vue&type=style&index=0&id=c6a7d6d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a7d6d4",
  null
  
)

export default component.exports